import {Base} from "@/api/Base"

export class SubjectListAll extends Base {
    path = "subject/listAll"
}